import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { ActiveSource, SourceTable } from 'types/GlobalDataset'

export const selectSimTable = createSelector(
  [(state: ApplicationState) => state.SimTableStore.data],
  (data) => data
)

export const selectSourcesFetched = createSelector(
  [(state: ApplicationState) => state.SimTableStore.sourcesFetched],
  (sourcesFetched) => sourcesFetched
)

export const selectShouldFetchSourceSchema = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) =>
      !state.SimTableStore.sourcesFetched &&
      !state.SimTableStore.fetchingSources
  ],
  (fetch) => fetch
)

export const selectActiveSources = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.SimTableStore.sourceSchemas
  ],
  (data): [Map<string, SourceTable>, ActiveSource[]] => {
    const activeSources = Object.values(data)
    const sourceTableMap = new Map<string, SourceTable>()

    activeSources.forEach((source) => {
      Object.entries(source.tables).forEach(([id, table]) => {
        sourceTableMap.set(id, table)
      })
    })

    return [sourceTableMap, activeSources]
  }
)
